import { getMessage } from '@/utils/notice';
import { debounce } from 'throttle-debounce';
import { studentSignInPath, teacherSignInPath } from '@/constants/route';
import getAppClient, { AppClientValue } from './getAppClient';

function anewSignIn(prompt?: string) {
  const signIn = () => {
    localStorage.removeItem('token');

    const appClient = getAppClient();
    window.open(
      appClient === AppClientValue.Student
        ? studentSignInPath
        : teacherSignInPath,
      '_self',
    );
  };

  if (prompt) {
    getMessage().error(prompt, 3, () => {
      signIn();
    });
  } else {
    signIn();
  }
}

export default debounce(3000, anewSignIn, {
  atBegin: true,
});
